import { ICustomMappings } from '@principle-theorem/practice-migrations/interfaces';
import { AppointmentCategoryToTreatmentCategoryMappingHandler } from '../exact/destination/mappings/appointment-category-to-treatment-category';
import { AppointmentRoomToPractionerMappingHandler } from '../exact/destination/mappings/appointment-room-to-practitioner';
import { ExactContactMappingHandler } from '../exact/destination/mappings/contact-to-referral-source';
import { ExactFeeScheduleMappingHandler } from '../exact/destination/mappings/fee-schedules';
import { ExactItemCodeToNoteMappingHandler } from '../exact/destination/mappings/item-code-to-notes';
import { PracticeWorksItemCodeToConditionMappingHandler } from './destination/mappings/item-code-to-condition';
import { PracticeWorksItemCodeToTreatmentMappingHandler } from './destination/mappings/item-code-to-treatment';
import { ExactItemCodeMappingHandler } from '../exact/destination/mappings/item-codes';
import { StaffToPracticeMapping } from '../exact/destination/mappings/practitioner-to-practice-mapping';
import { BaseCustomMappingsHandler } from '../mappings/base-custom-mappings-handler';
import { PracticeWorksItemCodeToTransactionTypeMappingHandler } from './destination/mappings/item-code-to-transaction-type';
import { PracticeWorksItemCodeMappingHandler } from './destination/mappings/item-codes';
import { PracticeWorksStafferMappingHandler } from './destination/mappings/staff';
import { PracticeWorkStaffToUserMappingHandler } from './destination/mappings/staff-to-user';

export const PRACTICE_WORKS_MAPPINGS: ICustomMappings = {
  metadata: {
    label: 'Practice Works Custom Mappings',
    description: '',
  },
};

export class PracticeWorksCustomMappingsHandler extends BaseCustomMappingsHandler {
  migrationType = 'Practice Works';
  migrationVersion = 'v1';
  customMapping = PRACTICE_WORKS_MAPPINGS;

  mappingHandlers = [
    new ExactItemCodeMappingHandler(),
    new PracticeWorksItemCodeMappingHandler(),
    new ExactContactMappingHandler(),
    new PracticeWorkStaffToUserMappingHandler(),
    new PracticeWorksStafferMappingHandler(),
    new PracticeWorksItemCodeToTreatmentMappingHandler(),
    new PracticeWorksItemCodeToConditionMappingHandler(),
    new ExactFeeScheduleMappingHandler(),
    new AppointmentCategoryToTreatmentCategoryMappingHandler(),
    new ExactItemCodeToNoteMappingHandler(),
    new AppointmentRoomToPractionerMappingHandler(),
    new StaffToPracticeMapping(),
    new PracticeWorksItemCodeToTransactionTypeMappingHandler(),
  ];
}
